import React, { useState } from 'react';
import axios from 'axios';
import { useCart } from '../../context/CartContext';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const StartProtocolSection = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    goal: ''
  });
  const [showSuccess, setShowSuccess] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  let cart = { saveUserProfile: () => {} };
  try {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    cart = useCart();
  } catch (e) {
    // Cart context not available
  }

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.name || !formData.email) return;
    
    setIsSubmitting(true);
    
    try {
      // Create profile in background
      await axios.post(`${BACKEND_URL}/api/protocol/start`, {
        name: formData.name,
        email: formData.email,
        phone: formData.phone || null,
        goal: formData.goal || null
      });
      
      // Save user profile for checkout auto-fill
      cart.saveUserProfile({
        name: formData.name,
        email: formData.email,
        phone: formData.phone
      });
      
      // Show success message
      setShowSuccess(true);
      
      // Redirect to products after 1.5 seconds
      setTimeout(() => {
        const productsSection = document.getElementById('products-section');
        if (productsSection) {
          productsSection.scrollIntoView({ behavior: 'smooth' });
        }
        // Reset form
        setFormData({ name: '', email: '', phone: '', goal: '' });
        setShowSuccess(false);
      }, 1500);
      
    } catch (error) {
      console.error('Error:', error);
      // Still redirect on error for seamless UX
      const productsSection = document.getElementById('products-section');
      if (productsSection) {
        productsSection.scrollIntoView({ behavior: 'smooth' });
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section 
      data-testid="start-protocol-section"
      className="w-full py-20 lg:py-28"
      style={{ backgroundColor: '#1A3D36' }}
    >
      <div className="max-w-lg mx-auto px-6">
        {/* Success Message */}
        {showSuccess && (
          <div 
            data-testid="success-message"
            className="mb-8 py-3 text-center text-sm"
            style={{ color: '#D4C9A8' }}
          >
            Your protocol has been initialized.
          </div>
        )}

        {/* Heading */}
        <h2 
          className="font-serif text-3xl lg:text-[32px] text-center mb-4"
          style={{ color: '#E8E6E1' }}
        >
          Start With Precision.
        </h2>

        {/* Subtext */}
        <p 
          className="text-base text-center mb-10"
          style={{ color: '#A8B3AC' }}
        >
          Every effective biology protocol begins with structured understanding before intervention.
        </p>

        {/* Form */}
        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            type="text"
            name="name"
            placeholder="Your Name"
            value={formData.name}
            onChange={handleChange}
            required
            className="w-full px-4 py-3.5 text-sm rounded-sm outline-none transition-all duration-200 focus:ring-1 focus:ring-[#D4C9A8]"
            style={{ 
              backgroundColor: 'rgba(255, 255, 255, 0.08)', 
              color: '#E8E6E1',
              border: '1px solid rgba(255, 255, 255, 0.15)'
            }}
            data-testid="input-name"
          />
          
          <input
            type="email"
            name="email"
            placeholder="Your Email"
            value={formData.email}
            onChange={handleChange}
            required
            className="w-full px-4 py-3.5 text-sm rounded-sm outline-none transition-all duration-200 focus:ring-1 focus:ring-[#D4C9A8]"
            style={{ 
              backgroundColor: 'rgba(255, 255, 255, 0.08)', 
              color: '#E8E6E1',
              border: '1px solid rgba(255, 255, 255, 0.15)'
            }}
            data-testid="input-email"
          />
          
          <input
            type="tel"
            name="phone"
            placeholder="Your Phone (Optional)"
            value={formData.phone}
            onChange={handleChange}
            className="w-full px-4 py-3.5 text-sm rounded-sm outline-none transition-all duration-200 focus:ring-1 focus:ring-[#D4C9A8]"
            style={{ 
              backgroundColor: 'rgba(255, 255, 255, 0.08)', 
              color: '#E8E6E1',
              border: '1px solid rgba(255, 255, 255, 0.15)'
            }}
            data-testid="input-phone"
          />
          
          <textarea
            name="goal"
            placeholder="What are you trying to solve? (Optional)"
            value={formData.goal}
            onChange={handleChange}
            rows={4}
            className="w-full px-4 py-3.5 text-sm rounded-sm outline-none resize-none transition-all duration-200 focus:ring-1 focus:ring-[#D4C9A8]"
            style={{ 
              backgroundColor: 'rgba(255, 255, 255, 0.08)', 
              color: '#E8E6E1',
              border: '1px solid rgba(255, 255, 255, 0.15)'
            }}
            data-testid="input-goal"
          />

          {/* CTA Button */}
          <button
            type="submit"
            disabled={isSubmitting}
            data-testid="cta-start-protocol"
            className="block w-full text-center px-6 py-4 text-sm font-medium rounded-sm transition-all duration-200 hover:opacity-90 disabled:opacity-70"
            style={{ 
              backgroundColor: '#D4C9A8', 
              color: '#1A3D36'
            }}
          >
            {isSubmitting ? 'Initializing...' : 'Start Your Protocol'}
          </button>

          {/* Note */}
          <p 
            className="text-[11px] text-center pt-2"
            style={{ color: '#6B7D73' }}
          >
            No spam. Structured guidance only.
          </p>
        </form>
      </div>
    </section>
  );
};

export default StartProtocolSection;
